import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBAlert, MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { deleteHuntGroup } from "../../../apiclients/streamsapi_bridge.js";

const DeleteHuntGroup = forwardRef((props, ref) => {
  const [internalError, setInternalError] = useState(false);
  const { t, i18n } = useTranslation();
  //const [isloading, setIsloading] = useState(false);

  async function removeThisGroup(e) {
    try {
      setInternalError(false);
      props.setIsloading(true);
      let deleteGrpReponse = await deleteHuntGroup(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.groupId);
      setTimeout(() => { props.setIsloading(false) }, 1000);
      let delInfo = await deleteGrpReponse.json();
      if (deleteGrpReponse.status == 200) {
        if (delInfo.status == 'success') {
          sessionStorage.setItem("hgroup_updated", true);
          localStorage.setItem("s_message", delInfo.message);
        } else {
          localStorage.setItem("f_message", delInfo.message);
        }
      } else if (delInfo.status == 400) {
        localStorage.setItem("f_message", delInfo?.message?.errors?.[0]?.message ?? delInfo?.message);
      } else if (delInfo.status == 500) {
        setInternalError(true);
      } else {
        localStorage.setItem("f_message", delInfo.message);
      }
      window.location.href = "/huntgroup";
      props.onClose();
    } catch (e) {
      console.log(`Unable to process Request :Internal server Error:!`);
      setInternalError(true);
    }
  }
  return (
    <>
      {internalError && (<MDBAlert
        open
        className="alert-center"
        color="danger"
        autohide
        position="bottom-right"
        delay={5000}
      >Internal Server Error</MDBAlert>)}
      <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
        <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />


        {((props.assocCFData && props.assocCFData.length > 0) || (props.assocLunaHops && props.assocLunaHops.length > 0)) ? (
          <>
            {props.assocCFData && props.assocCFData.length > 0 && (
              <div>
                <span >{t("associated_cflows")}<br />{props.assocCFData?.map(obj => (' ' + obj.name + ' : ' + obj.extension + ' ')).toString()} </span>
              </div>
            )}
            {props.assocLunaHops && props.assocLunaHops.length > 0 && (
              <div>
                <span >{t("associated_lunahops")}<br />{props.assocLunaHops.join(", ")} </span>
              </div>
            )}

            <div style={{ display: "none" }}>
              <button ref={ref} onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                props.onClose();
              }}>
                {t("okay")}</button>
            </div>
          </>

        ) : (
          <>
            <div>
              <span>{t("RemoveHunttxt")}</span>
            </div>

            <div style={{ display: "none" }}>
              <button ref={ref} onClick={(e) => removeThisGroup(e)}>
                {t("remove")}</button>
            </div>
          </>

        )}


      </div>



      {/* <MDBModalFooter>
        <MDBBtn color="secondary" onClick={props.onClose}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={(e) => removeThisGroup(e)}>{t("remove")}</MDBBtn>
      </MDBModalFooter> */}
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
    </>
  );
});

export default DeleteHuntGroup;
